import Vue from 'vue'
import Element from 'element-ui'
import '@/plugins/index.js'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
// import '@/assets/iconfont/font.css' // font图标库
import '@/assets/js/iconfont.js'
import App from './App'
import store from './store'
import { router } from './router'
import { ActionType } from './bean/UserAction'
import { globalMixin } from './mixins/global-mixin'
import './registerServiceWorker'
import './compatibility'
Vue.mixin(globalMixin)
Vue.use(Element, {
  size: 'medium' // set element-ui default size
})
Vue.config.productionTip = false
Vue.prototype.webWorker = new Worker('/js/web-work.js')
Vue.prototype.ActionType = ActionType
Vue.prototype.eventBus = new Vue()
Vue.prototype.userActionBus = new Vue()
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
